import React, { useState } from 'react'
import { useQuery } from '@tanstack/react-query'
import { color, useAuthedRequestFn } from '@my/util'
import { Spinner, XStack, YStack, useWindowDimensions, useMedia, ScrollView } from '@my/ui'

import { FinancialReviewHeading } from '../../../components/index'
import { ExpandableInsightsCard } from './expandableInsightCard'
import { KeyInsightCard } from './insightCard'
import { TipModal } from './tipModal'
import images from '../../../assets/images/index'
import { Platform } from 'react-native'

// Helper to map insight data into structured card items
const RenderInsightCard = ({
  item,
  index,
  width,
  onPressAddTip,
}: {
  item: any
  index: number
  width: number
  onPressAddTip: (data) => void
}) => {
  const media = useMedia();
  const maxWidth = media['max-sm'] ? 380 : 450
  return <XStack style={{
    position: 'relative', maxWidth, width: '100%', //minWidth: 320, 
  }}>
    <ExpandableInsightsCard
      key={index}
      index={index}
      title={item.keyInsight}
      value={item?.description}
      tipsData={item?.tips}
      isBookMarked={index % 2 == 0}
      isLiked={index % 2 !== 0}
      onPressAddTip={onPressAddTip}
      item={item}
      startExpanded={index === 0}
      maxWidth={maxWidth}
    />
  </XStack>
}

export const KeyInsights = () => {
  const { width } = useWindowDimensions()
  const [isTipDialogVisible, setIsTipDialogVisible] = useState<boolean>(false)
  const [organizeIn, setOrganizeIn] = useState<string>('')

  const authedRequestFn = useAuthedRequestFn()

  const { data: insightData, isLoading } = useQuery({
    queryKey: ['financial-review'],
    queryFn: () => authedRequestFn('/financial-review'),
  })

  const openModal = (e: any) => {
    setIsTipDialogVisible(true)
  }

  const output = (
    <YStack p="$4" bg={'#fff'} gap={20}>
      <FinancialReviewHeading
        title="Key Insights"
        img={images.keyInsight}
        imageStyle={{
          //'$platform-native': { width: 22, height: 21 },
          //'$platform-web': { width: 25, height: 26 },
          resizeMode: 'contain',
        }}
      />
      {isLoading && <Spinner size="large" color={color.tzaGreen} />}
      <XStack flexWrap="wrap" width={'100%'} gap={20}>
        {insightData?.insights?.map((item, index) => (
          <RenderInsightCard
            key={index}
            item={item}
            index={index}
            width={width}
            onPressAddTip={openModal}
          />
        ))}
      </XStack>
      {/* <XStack justifyContent={'center'} marginVertical={'$4'}>
        <ActionButton
          unstyled
          borderRadius={100}
          flexDirection="row"
          bg={color.toggleGreen}
          height={40}
          width={230}
          paddingHorizontal={20}
          alignItems="center"
          justifyContent="center"
        >
          <Plus height={13} width={13} color={color.grey} />
          <SimpleText fontSize={16} fontWeight="600" color={color.grey}>
            View More Insights
          </SimpleText>
        </ActionButton>
      </XStack> */}

      {isTipDialogVisible && (
        <TipModal
          isOpen={isTipDialogVisible}
          onClose={() => setIsTipDialogVisible(false)}
          organizeIn={organizeIn}
          setOrganizeIn={setOrganizeIn}
        />
      )}
    </YStack>
  )

  return (
    Platform.OS === 'web' ? (
      output
    ) : (
      <ScrollView backgroundColor={color.white}>
        {output}
      </ScrollView>
    )
      
  )
}
